module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/incoming-mail-e98035c63aaeb19e9b72abc14580fe33.svg";